import axios from '@/utils/request'
import utils from '@/utils/index.js'
var Qs = require('qs')

export default {


  states_all: ['confirming', 'placed', 'pending', 'preparing', 'prepared', 'purchasing', 'purchased', 'processing', 'processed', 'forout', 'shipped', 'partially', 'finished', 'canceled', 'returned'],

  states_pre: ['confirming', "placed", "pending"],
  states_available: ["preparing", "prepared"],
  states_manufacture: ["processing", "processed"],
  states_purchase: ["purchasing", "purchased"],
  states_after: ["forout", "shipped", "partially", "finished", "canceled", "returned"],
  states_no_permint: [
    { key: 'placed', workflowStates: ['placed'] },
    { key: 'confirming', workflowStates: ['confirming'] },
    { key: 'pending', workflowStates: ['pending'] },
    { key: 'dealing', workflowStates: ['preparing', 'processing', 'purchasing'] },
    { key: 'dealed', workflowStates: ['prepared', 'processed', 'purchased', "forout",] },
    { key: 'shipped', workflowStates: ['shipped'] },
    { key: 'partially', workflowStates: ['partially'] },
    { key: 'finished', workflowStates: ['finished'] },
    { key: 'canceled', workflowStates: ['canceled'] },
    { key: 'returned', workflowStates: ['returned'] }
  ],
  states_replenish: ['pending', 'preparing', 'prepared', 'purchasing', 'purchased', 'processing', 'processed', 'shipped', 'partially', 'finished', 'canceled', 'returned'],
  states_no_permint_replenish: [
    { key: 'pending', workflowStates: ['pending'] },
    { key: 'dealing', workflowStates: ['preparing', 'processing', 'purchasing'] },
    { key: 'dealed', workflowStates: ['prepared', 'processed', 'purchased'] },
    { key: 'shipped', workflowStates: ['shipped'] },
    { key: 'partially', workflowStates: ['partially'] },
    { key: 'finished', workflowStates: ['finished'] },
    { key: 'canceled', workflowStates: ['canceled'] },
    { key: 'returned', workflowStates: ['returned'] }
  ],
  states_delivery: ['forout', 'shipped', 'partially', 'finished',],

  passRange: [
    { label: '1天', key: 'pass1', condition: { passRangeStart: 1, passRangeEnd: 1 } },
    { label: '2天', key: 'pass2', condition: { passRangeStart: 2, passRangeEnd: 2 } },
    { label: '3天', key: 'pass3', condition: { passRangeStart: 3, passRangeEnd: 3 } },
    { label: '4-7天', key: 'pass4', condition: { passRangeStart: 4, passRangeEnd: 7 } },
    { label: '全部', key: 'pas-all', condition: { passRangeStart: 1, passRangeEnd: 100 } }
  ],
  nearRange: [
    { label: '今天', key: 'near-today', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(new Date())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(new Date())) + ' 23:59:59' } },
    { label: '明天', key: 'near-tomorrow', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(1))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(1))) + ' 23:59:59' } },
    { label: '后天', key: 'near-datmr', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(2))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(2))) + ' 23:59:59' } },
    { label: '4-7天', key: 'near-4-7', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.nextNDay(3))) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfDay(utils.nextNDay(6))) + ' 23:59:59' } },
    { label: '本周', key: 'near-week', condition: { nearRangeStart: utils.formatDate(utils.beginOfDay(utils.beginOfThisWeek())) + ' 00:00:00', nearRangeEnd: utils.formatDate(utils.endOfThisWeek()) + ' 23:59:59' } }
  ],
  // 2020-10-23
  search(params) {
    return axios.get('/orders?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-13
  saleSearchCount(params) {
    return axios.get('/orders/sale-search-count?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-10-23
  pendingSearch(params) {
    return axios.get('/orders/pendings?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2022-03-10
  pendingsExportExcel(params) {
    return axios.get('/orders/pendings-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-01-08
  pendingRequisitionSearch(params) {
    return axios.get('/orders/pending-requisitions?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-01-16
  materialAccountingSearch(params) {
    return axios.get('/orders/material-accounting-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2020-11-06
  replenishSearch(params) {
    return axios.get('/orders/replenish-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2021-03-06
  saleSearch(params) {
    return axios.get('/orders/sale-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2022-02-26
  pendingDeliverySearch(params) {
    return axios.get('/orders/pending-delivery-search?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
  },
  // 2022-02-26
  pendingDeliveryCount() {
    return axios.get('/orders/pending-delivery-count')
  },
  // 2020-09-25
  create(params) {
    return axios.post('/orders', params)
  },
  // 2020-11-06
  batchReplenish(params) {
    return axios.post('/orders/batch-replenish', params)
  },
  // 2020-09-26
  insertBatch(params) {
    return axios.post('/orders/insert-batch', params)
  },
  // 2020-09-15
  findBySerialNo(params) {
    return axios.get('/orders/find-by-serial-no', params)
  },
  // 2020-09-19
  batchConfirm(params) {
    return axios.put('/orders/batch-confirm', params)
  },

  // 2023-07-14
  confirmByBargainId(bargainId) {
    return axios.put('/orders/confirm-by-bargain-id/' + bargainId)
  },
  // 2020-10-21
  update(id, params) {
    return axios.put('/orders/' + id, params)
  },
  //2020-09-21
  updateFlags(params) {
    return axios.put('/orders/update-flags', params)
  },
  // 2020-10-16
  updateSettleRemark(params) {
    return axios.put('/orders/update-settle-remark', params)
  },
  // 2020-10-24
  updateRemark(params) {
    return axios.put('/orders/update-remark', params)
  },
  // 2020-10-25
  updateDealRemark(params) {
    return axios.put('/orders/update-deal-remark', params)
  },
  // 2021-05-19
  updateOrderRemark(params) {
    return axios.put('/orders/update-order-remark', params)
  },
  // 2020-10-21
  hurry(id) {
    return axios.put('/orders/' + id + '/hurry')
  },
  // 2020-10-21
  delete(id) {
    return axios.delete('/orders/' + id)
  },
  // 2020-10-21
  batchConfirm(params) {
    return axios.put('/orders/batch-confirm', params)
  },
  // 2020-10-21
  batchCancelConfirm(params) {
    return axios.put('/orders/batch-cancel-confirm', params)
  },
  // 2020-10-22
  updatePrice(params) {
    return axios.put('/orders/update-price', params)
  },
  // 2020-10-22
  cancel(params) {
    return axios.put('/orders/cancel', params)
  },
  // 2020-10-22
  returnBack(params) {
    return axios.put('/orders/return-back', params)
  },

  // 2020-10-23
  batchPrepareing(params) {
    return axios.put('/orders/batch-prepareing', params)
  },
  // 2020-10-24
  batchPrePurchaseing(params) {
    return axios.put('/orders/batch-pre-purchaseing', params)
  },
  // 2020-10-24
  batchPurchase(params) {
    return axios.put('/orders/batch-purchase', params)
  },
  // 2020-10-24
  batchPreProcessing(params) {
    return axios.put('/orders/batch-pre-processing', params)
  },
  // 2020-10-24
  batchProcessing(params) {
    return axios.put('/orders/batch-processing', params)
  },
  // 2020-10-24
  batchPause(params) {
    return axios.put('/orders/batch-pause', params)
  },
  // 2021-05-12
  batchRemovePause(params) {
    return axios.put('/orders/batch-remove-pause', params)
  },
  // 2020-10-25
  batchPrepared(params) {
    return axios.put('/orders/batch-prepared', params)
  },
  // 2020-10-25
  availablePartDeal(params) {
    return axios.put('/orders/available-part-deal', params)
  },
  // 2020-10-26
  availableRepending(id) {
    return axios.put('/orders/' + id + '/available-repending',)
  },
  // 2020-10-26
  changeSpecPrepared(params) {
    return axios.put('/orders/change-spec-prepared', params);
  },
  // 2020-10-26
  batchProcessed(params) {
    return axios.put('/orders/batch-processed', params)
  },
  // 2020-10-26
  manufacturePartDeal(params) {
    return axios.put('/orders/manufacture-part-deal', params)
  },
  // 2020-10-26
  manufactureRepending(id) {
    return axios.put('/orders/' + id + '/manufacture-repending',)
  },
  // 2020-10-26 生产中页面下载生产单
  downloadPdf(params) {
    return axios.post('/orders/download-pdf', params)
  },
  // 2020-10-26
  batchPrint(params) {
    return axios.post('/orders/batch-print', params)
  },
  // 2020-09-26
  findBySerialNos(params) {
    return axios.post('/orders/find-by-serial-nos', params)
  },
  // 2020-09-07
  findCustomOrderByInventoryId(params) {
    return axios.get('/orders/find-custom-order-by-inventory-id', params)
  },
  // 2020-10-30
  copy(id, params) {
    return axios.put('/orders/' + id + '/copy', params);
  },
  // 2020-10-30
  copyToNewBargain(id, params) {
    return axios.put('/orders/' + id + '/copy-to-new-bargain', params);
  },
  // 2020-10-30
  reject(id, params) {
    return axios.put('/orders/' + id + '/reject', params)
  },
  // 2020-10-31
  remake(params) {
    return axios.post('/orders/remake', params)
  },
  // 2020-10-31
  hang(id, params) {
    return axios.put('/orders/' + id + '/hang', params);
  },
  // // 2020-11-04
  // batchReceive(params) {
  //   return axios.put('/orders/batch-receive', params);
  // },
  // // 2020-11-04
  // changeSpecsReceive(params) {
  //   return axios.put('/orders/change-specs-receive', params);
  // },
  // 2020-11-16 送货自提
  normalDeliver(params) {
    return axios.put('/orders/normal-deliver', params)
  },
  // 2020-11-16 国内快递发货
  expressDeliver(params) {
    return axios.put('/orders/express-deliver', params)
  },
  // 2020-11-16 货代发货
  courierDeliver(params) {
    return axios.put('/orders/courier-deliver', params)
  },

  // 2020-11-27
  pendingCount() {
    return axios.get('/orders/pending-count');
  },
  // 2020-11-27
  preparingCount() {
    return axios.get('/orders/preparing-count');
  },
  // 2020-11-27
  processingCount() {
    return axios.get('/orders/processing-count');
  },
  // 2020-11-27
  purchasingCount() {
    return axios.get('/orders/purchasing-count');
  },
  // 2020-12-08
  unSettle(params) {
    return axios.get('/orders/un-settle', params)
  },
  // 2020-12-10
  nearQtys() {
    const rangesTxts = this.nearRange.map(pr => pr.condition.nearRangeStart + '---' + pr.condition.nearRangeEnd)
    return axios.get('/orders/near-qtys?' + Qs.stringify({ dates: rangesTxts }, { arrayFormat: 'repeat' }));
  },
  // 2020-12-10
  passQtys() {
    const rangesTxts = this.passRange.map(pr => pr.condition.passRangeStart + '-' + pr.condition.passRangeEnd)
    return axios.get('/orders/pass-qtys?' + Qs.stringify({ passRange: rangesTxts }, { arrayFormat: 'repeat' }));
  },

  // 2020-12-30
  batchScanProcessed(params) {
    return axios.put('/orders/batch-scan-processed', params)
  },
  // 2021-01-23
  pausePendingCount() {
    return axios.get('/orders/pause-pending-count');
  },


  // 2021-03-01
  asyncProductToPdm(id) {
    return axios.put('/orders/' + id + '/async-product-to-pdm')
  },
  // 2021-03-05
  replenishExportExcel(params) {
    return axios.get('/orders/replenish-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-03-06
  saleExportExcel(params) {
    return axios.get('/orders/sale-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },

  // 2021-03-11
  productSaleRankingReport(params) {
    return axios.get('/orders/product-sale-ranking-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-03-11
  productSaleRankingReportExportExcel(params) {
    return axios.get('/orders/product-sale-ranking-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-02-14
  findByUuid(params) {
    return axios.get('/orders/find-by-uuid', params);
  },
  // 2021-04-08
  salesRevenueReport(params) {
    return axios.get('/orders/sales-revenue-report?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-08
  salesRevenueReportExportExcel(params) {
    return axios.get('/orders/sales-revenue-report-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-08
  salesRevenueReportDiff(params) {
    return axios.get('/orders/sales-revenue-report-diff?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-23
  salesRevenueReportDiffExportExcel(params) {
    return axios.get('/orders/sales-revenue-report-diff-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-24
  salesRevenueReportSaleDetail(params) {
    return axios.get('/orders/sales-revenue-report-sale-detail?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-28
  salesRevenueReportSaleDetailExportExcel(params) {
    return axios.get('/orders/sales-revenue-report-sale-detail-export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2021-04-26
  batchAsyncProcessing(params) {
    return axios.put('/orders/batch-async-processing', params);
  },
  // 2021-05-18
  saleLineChart(params) {
    return axios.get('/orders/sale-line-chart', params);
  },

  // 2021-05-19
  findBySaleSettlementIdAndBarginId(saleSettlementId, bargainId) {
    return axios.get('/orders/find-by-sale-settlement-id-and-bargin-id/' + saleSettlementId + '/' + bargainId);
  },

  // 2021-06-07
  trackWorkInfos(id) {
    return axios.get('/orders/' + id + '/track-work-infos');
  },
  // 2021-06-24
  quoted(id, params) {
    return axios.put('/orders/' + id + '/quoted', params)
  },

  // 2021-07-27
  productLifeCycle(params) {
    return axios.get('/orders/product-life-cycle', params)
  },

  // 2021-09-01
  findWithProductByUuids(params) {
    return axios.post('/orders/find-with-product-by-uuids', params)
  },
  // 2021-09-18
  knockInvByIds(params) {
    return axios.put('/orders/knock-inv-by-ids', params)
  },
  // 2021-09-18
  knockDeal(params) {
    return axios.put('/orders/knock-deal', params)
  },
  // 2021-10-27
  updateAttachment(id, params) {
    return axios.put('/orders/' + id + '/update-attachment', params)
  },
  // 2022-03-29
  preDeliver(params) {
    return axios.put('/orders/pre-deliver', params)
  },
  // 2023-06-25
  pendingRequisitionsCount() {
    return axios.get('/orders/pending-requisitions-count');
  },
  // 2020-10-15
  findById(id) {
    return axios.get('/orders/' + id);
  },

}